import { useMemo } from 'react'

const hotelsDestinations = ['Bali', 'Phuket', 'Europe', 'Australia']

export function useTrendingDestinationsLabels(trendingDestinations: Array<App.TrendingDestination>) {
  return useMemo(() => (
    trendingDestinations.length ? trendingDestinations.map(destination => destination.primaryText) : hotelsDestinations
  ), [trendingDestinations])
}
